import { render, staticRenderFns } from "./PassRegist.vue?vue&type=template&id=1f83923a&scoped=true"
import script from "./PassRegist.vue?vue&type=script&lang=js"
export * from "./PassRegist.vue?vue&type=script&lang=js"
import style0 from "./PassRegist.vue?vue&type=style&index=0&id=1f83923a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f83923a",
  null
  
)

export default component.exports